{
  "name": "cliniva",
  "version": "259.01.08.10",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.6",
    "@angular/cdk": "^21.0.5",
    "@angular/common": "^21.0.6",
    "@angular/compiler": "^21.0.6",
    "@angular/core": "^21.0.6",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "^21.0.6",
    "@angular/google-maps": "^16.0.0",
    "@angular/localize": "^21.0.6",
    "@angular/material": "^21.0.5",
    "@angular/material-moment-adapter": "^21.0.5",
    "@angular/platform-browser": "^21.0.6",
    "@angular/platform-browser-dynamic": "^21.0.6",
    "@angular/router": "^21.0.6",
    "@ckeditor/ckeditor5-angular": "^6.0.1",
    "@ckeditor/ckeditor5-build-classic": "^37.1.0",
    "@danielmoncada/angular-datetime-picker": "^15.0.2",
    "@fullcalendar/angular": "^6.1.7",
    "@fullcalendar/core": "^6.1.7",
    "@fullcalendar/daygrid": "^6.1.7",
    "@fullcalendar/interaction": "^6.1.7",
    "@fullcalendar/list": "^6.1.7",
    "@fullcalendar/timegrid": "^6.1.7",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ngx-loading-bar/core": "^6.0.2",
    "@ngx-loading-bar/router": "^6.0.2",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@popperjs/core": "^2.11.7",
    "@sweetalert2/ngx-sweetalert2": "^12.2.0",
    "@swimlane/ngx-charts": "^20.1.2",
    "@swimlane/ngx-datatable": "^20.1.0",
    "@types/d3-shape": "^3.1.1",
    "algoliasearch": "^5.20.2",
    "angular-feather": "^6.5.0",
    "apexcharts": "^3.40.0",
    "bootstrap": "^5.2.3",
    "bootstrap-icons": "^1.10.5",
    "browser-sync": "^3.0.4",
    "chart.js": "^4.3.0",
    "core-js": "^3.30.2",
    "echarts": "^5.4.2",
    "firebase": "^11.0.0",
    "firebase-tools": "^0.1.6",
    "luxon": "^3.7.2",
    "moment": "^2.29.4",
    "ng-apexcharts": "^1.7.6",
    "ng2-charts": "^4.1.1",
    "ngx-dropzone-wrapper": "^14.0.0",
    "ngx-echarts": "^15.0.3",
    "ngx-gauge": "^7.0.0",
    "ngx-mask": "^15.1.3",
    "ngx-scrollbar": "^11.0.0",
    "rxjs": "~7.8.1",
    "socket.io-client": "^4.8.1",
    "subsink": "^1.0.2",
    "sweetalert2": "^11.7.27",
    "tslib": "^2.5.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^16.1.1",
    "@angular-eslint/eslint-plugin": "16.0.1",
    "@angular-eslint/eslint-plugin-template": "16.0.1",
    "@angular-eslint/schematics": "^16.1.1",
    "@angular-eslint/template-parser": "16.0.1",
    "@angular/build": "^21.0.4",
    "@angular/cli": "^21.0.4",
    "@angular/compiler-cli": "^21.0.6",
    "@types/ckeditor__ckeditor5-build-classic": "^29.0.1",
    "@types/d3": "^7.4.0",
    "@types/echarts": "^4.9.17",
    "@types/jasmine": "~4.3.1",
    "@types/luxon": "^3.7.1",
    "@typescript-eslint/eslint-plugin": "^5.59.5",
    "@typescript-eslint/parser": "^5.59.5",
    "eslint": "^8.40.0",
    "jasmine-core": "~4.6.0",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "typescript": "~5.9.3"
  }
}
